import { useQuery } from '@tanstack/react-query';

/** One firm's billing at one month-end, as GET /admin/billing/history returns it. */
type BillingSnapshot = {
  /** First of the month, YYYY-MM-DD. */
  month: string;
  companyId: string;
  activeBillableUnitCount: number;
};

export const useBillingSnapshots = () =>
  useQuery<BillingSnapshot[]>({ queryKey: ['admin', 'billing', 'history'] });
